import { useCallback } from 'react';
import { TLoadingOpts, useLoadingStore } from '@/stores/feedback';
import { requestConfirm } from '@/widgets/confirm/confirm-service';

export const useFeedback = () => {
  const startLoading = useLoadingStore((state) => state.startLoading);
  const finishLoading = useLoadingStore((state) => state.finishLoading);

  // confirm 的排队与结算都收敛在 confirm-service，这里只透传，
  // 引用恒定，不会让调用方的 useCallback 依赖反复失效
  const showConfirm = requestConfirm;

  const showLoading = useCallback(
    (options: TLoadingOpts) => {
      startLoading({
        pseudo: false,
        progress: options.progress,
        variant: options.variant,
        content: options.content,
        duration: options.duration,
        hideProgressBar: options.hideProgressBar
      });
    },
    [startLoading]
  );

  const hideLoading = useCallback(() => {
    finishLoading();
  }, [finishLoading]);

  const startPseudoLoading = useCallback(
    (options?: TLoadingOpts) => {
      startLoading({
        pseudo: true,
        progress: 0,
        variant: options?.variant ?? 'overlay',
        content: options?.content,
        duration: options?.duration ?? 10000,
        hideProgressBar: options?.hideProgressBar ?? false
      });
    },
    [startLoading]
  );

  const finishPseudoLoading = useCallback(() => {
    finishLoading();
  }, [finishLoading]);

  return {
    showConfirm,
    showLoading,
    hideLoading,
    startPseudoLoading,
    finishPseudoLoading
  };
};
